<template>
  <div class="home">
    <v-row class="pa-8" justify="space-between">
      <v-col cols="12" md="6" sm="12" xs="12">
        <v-row class="ma-0">
          <v-col cols="12" md="2" sm="0" xs="0" class="hidden-md-and-down">
            <v-img
              src="@/assets/hci-logos/onlyIcon/onlyIcon-noBG.png"
              alt="Human Computer Interaction - logo"
            ></v-img>
          </v-col>
          <v-col cols="12" md="10" sm="12" xs="12">
            <h4 class="pl-4" style="letter-spacing: 5px">
              {{ $t("HOME.subtitle") }}
            </h4>
            <h1 class="pl-4">{{ $t("HOME.title") }}</h1>

            <v-row class="pl-4 ma-0 pb-4" align="center">
              <v-chip
                outlined
                color="#2f3860"
                class="mt-2 mr-2"
                style="pointer-events: none"
              >
                <v-icon left>{{ icon.mdiEarth }}</v-icon>
                {{ $t("HOME.hybrid") }}
              </v-chip>
              <v-chip
                outlined
                color="#2f3860"
                class="mt-2"
                style="pointer-events: none"
              >
                <v-icon left>{{ icon.mdiCurrencyUsdOff }}</v-icon>
                {{ $t("HOME.free") }}
              </v-chip>
            </v-row>
            <v-row class="ma-0 pb-4" align="center">
              <a
                @click="gtagEmit('twitter_tag_clicked')"
                class="ml-4"
                :href="event_tag_url"
                rel="noopener noreferrer"
                target="_blank"
                id="twitter-tag"
                >{{ tag }}</a
              >
            </v-row>
            <v-row class="pl-4 ma-0 pb-4">
              <v-icon left color="blue">{{ icon.mdiCalendarBlank }}</v-icon>
              <a
                @click="gtagEmit('calendar_clicked')"
                :href="event_calendar_url"
                rel="noopener noreferrer"
                target="_blank"
                id="date-tag"
                >{{ $t("HOME.date") }}</a
              >
            </v-row>
            <v-row class="pl-4 ma-0 pb-0">
              <v-icon left color="blue">{{ icon.mdiMapMarker }}</v-icon>
              <a
                id="location-tag"
                @click="gtagEmit('location_clicked')"
                :href="event_location_url"
                rel="noopener noreferrer"
                target="_blank"
                >{{ $t("HOME.location") }}</a
              >
            </v-row>
            <v-row class="pl-4 ma-0 pb-0 pt-4">
              <v-icon left color="blue">{{ icon.mdiEmail }}</v-icon>

              <a
                @click="gtagEmit('contact_clicked')"
                :href="`mailto:jornadasihc2021@gmail.com`"
                rel="noopener noreferrer"
                target="_blank"
                id="contact-tag"
              >
                {{ $t("HOME.contact") }}
              </a>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" sm="12" xs="12" class="countdown-box">
        <v-alert
          color="success"
          outlined
          :icon="icon.mdiSchool"
          border="left"
          prominent
        >
          {{ $t("HOME.info_box_minicourses") }} <a href="help">{{ $t("METAINFO.help.tab_title") }}</a>
        </v-alert>
        <!-- <countdown /> -->
        <support-logos />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import Countdown from "@/components/atoms/FlipCountdown.vue";
import SupportLogos from "@/components/molecules/home/SupportLogos.vue";

import {
  mdiCalendarBlank,
  mdiMapMarker,
  mdiEarth,
  mdiCurrencyUsdOff,
  mdiEmail,
  mdiSchool,
} from "@mdi/js";

export default {
  name: "Home",
  components: {
    // Countdown,
    SupportLogos,
  },
  metaInfo() {
    return {
      meta: [
        { name: "title", content: `${this.$i18n.t("METAINFO.home.title")}` },
        {
          name: "description",
          content: `${this.$i18n.t("METAINFO.home.description")}`,
        },
        {
          name: "keywords",
          content: `${this.$i18n.t("METAINFO.home.keywords")}`,
        },
        // OpenGraph data
        { property: "og:title", content: "HCI 2021" },
        { property: "og:url", content: "https://hci2021.web.app/" },
        {
          property: "og:description",
          content: `${this.$i18n.t("METAINFO.home.description")}`,
        },

        // Twitter card
        { name: "twitter:card", content: "summary" },
        { name: "twitter:site", content: "https://hci2021.web.app/" },
        { name: "twitter:title", content: "HCI 2021" },
        {
          name: "twitter:description",
          content: `${this.$i18n.t("METAINFO.home.description")}`,
        },

        //Google Schema
        { itemprop: "name", content: "HCI 2021" },
        {
          itemprop: "description",
          content: `${this.$i18n.t("METAINFO.home.description")}`,
        },
      ],
      link: [{ rel: "canonical", href: "https://hci2021.web.app/" }],
    };
  },

  data() {
    return {
      location: "Mackenzie, São Paulo, SP",
      tag: "#JornadasHCI",
      event_calendar_url:
        "https://www.google.com/calendar/render?action=TEMPLATE&text=VII+Jornadas+HCI+2021&location=Mackenzie%2C+SP&dates=20210908T141800Z%2F20210910T141800Z",
      event_location_url: "https://goo.gl/maps/6nFr1gcm5z2eGNHYA",
      event_tag_url:
        "https://twitter.com/search?q=%23JornadasHCI&src=typed_query",
      icon: {
        mdiMapMarker: mdiMapMarker,
        mdiCalendarBlank: mdiCalendarBlank,
        mdiEarth: mdiEarth,
        mdiCurrencyUsdOff,
        mdiEmail,
        mdiSchool,
      },
    };
  },
  methods: {
    gtagEmit(eventName) {
      if (typeof window.gtag == "function") {
        window.gtag("event", eventName);
      }
    },
  },
  async mounted() {
    this.$store.dispatch("getTalks");
  },
};
</script>

<style>
.home {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
}

@media (max-width: 480px) {
  .home {
    background-image: url("~@/assets/others/Man.svg");
    background-position-y: 100%;
    background-position-x: 0%;
  }
}
@media (min-width: 481px) and (max-width: 1024px) and (orientation: portrait) {
  .home {
    background-image: url("~@/assets/others/ManFlipped.svg");
    background-position-y: 100%;
    background-position-x: 100%;
  }
}
@media (min-width: 481px) and (max-width: 1024px) and (orientation: landscape) {
  .home {
    background-image: url("~@/assets/others/ManFlipped.svg");
    background-position-y: 100%;
    background-position-x: 100%;
  }
}
@media (min-width: 1025px) {
  .home {
    margin-top: 3%;
    background-image: url("~@/assets/others/ManFlipped.svg");
    background-position-y: 100%;
    background-position-x: 55%;
  }
  .home {
    background-position-y: 100%, 50%, 60%, 80%;
    background-position-x: 100%, 66%, 82%, 92%;
  }
}

.slide-in {
  animation: 1s ease-out 0s 1 slideInFromRight;
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
  }
  60% {
    transform: translateX(-20%);
  }
  90% {
    transform: translateX(10%);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
